export default async function UpdateProjectExpense(sendForm) {
    let url = window.RealestateService+  `/api/ProjectExpense/UpdateProjectExpense`
    let head = {
        'Content-Type': 'application/json',
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"POST",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}